module.exports = __webpack_public_path__ + "img/default-avatar.6ea4ec4.jpg";